import { render, staticRenderFns } from "./pianqu2Detail.vue?vue&type=template&id=f288b72e&scoped=true"
import script from "./pianqu2Detail.vue?vue&type=script&lang=js"
export * from "./pianqu2Detail.vue?vue&type=script&lang=js"
import style0 from "./pianqu2Detail.vue?vue&type=style&index=0&id=f288b72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f288b72e",
  null
  
)

export default component.exports